import React from "react";
import glamorous from "glamorous";

import { ExceptionRow } from "../exceptions/ExceptionLink";
import EventsListContainer from "../events/EventsListContainer";
import WatchlistModal from "./WatchlistModal";
import { WatchlistPanel } from "./WatchlistPanel";

import Colors from "../../styles/colors";
import {
  PanelContainer,
  Panel
} from "../../vendor/signal-widgets/components/panel";
import ShipmentSearchBar from "../shipment-search/ShipmentSearchBar";

// Panels
const AllShipmentsPanel = props => {
  const {
    allShipmentsTotals,
    pushSearchView,
    searchShipments,
    exceptionTypes,
    setSearchFilter,
    clearSearchFilters,
    setSearchCategory,
    setSearch
  } = props;

  return (
    <Panel
      title={"All Shipments"}
      canMaximize={false}
      style={{ border: "none" }}
      headerStyle={{
        backgroundColor: Colors.background.DARK_BLUE,
        color: "white",
        fontWeight: "300"
      }}
    >
      <ExceptionRow
        shipmentsTotals={allShipmentsTotals}
        pushSearchView={pushSearchView}
        searchShipments={searchShipments}
        exceptionTypes={exceptionTypes}
        setSearchFilter={setSearchFilter}
        clearSearchFilters={clearSearchFilters}
        setSearchCategory={setSearchCategory}
        setSearch={setSearch}
        site={null}
        part={null}
      />
    </Panel>
  );
};

const Section = glamorous.section({
  display: "flex",
  flex: 1,
  flexDirection: "row",
  justifyContent: "space-between",
  padding: "1em",
  paddingTop: "0em"
});

export default class ShipmentStatusView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showWatchlistModal: false,
      selectedWatchlistItem: null
    };
  }

  componentDidMount() {
    const {
      fetchSavedSearches,
      fetchShipmentTotals,
      fetchWatchlist
    } = this.props;

    console.log("--componentWillMount--");

    fetchSavedSearches();
    fetchWatchlist();
    fetchShipmentTotals();
  }

  render() {
    const {
      allShipmentsTotals,
      watchlistData,
      watchlistShipments,
      fetchShipmentTotalsByPart,
      fetchShipmentTotalsByLocation,
      pushLocationDetailView,
      locations,
      lads,
      pushSearchView,
      searchShipments,
      exceptionTypes,
      setSearchFilter,
      clearSearchFilters,
      setSearchCategory,
      setSearch
    } = this.props;
    const { showWatchlistModal, selectedWatchlistItem } = this.state;

    const watchlistPanels = watchlistData.map((d, i) => (
      <WatchlistPanel
        key={i}
        watchlistShipments={watchlistShipments}
        locations={locations}
        lads={lads}
        fetchShipmentTotalsByLocation={fetchShipmentTotalsByLocation}
        fetchShipmentTotalsByPart={fetchShipmentTotalsByPart}
        site={d.location_id}
        part={d.part_value}
        editWatchlistItem={() =>
          this.setState({ selectedWatchlistItem: d, showWatchlistModal: true })
        }
        pushLocationDetailView={pushLocationDetailView}
        pushSearchView={pushSearchView}
        searchShipments={searchShipments}
        exceptionTypes={exceptionTypes}
        setSearchFilter={setSearchFilter}
        clearSearchFilters={clearSearchFilters}
        setSearchCategory={setSearchCategory}
        setSearch={setSearch}
      />
    ));

    return (
      <glamorous.Div css={{ display: "flex", flexDirection: "column" }}>
        <glamorous.Div
          css={{ marginTop: "1em", marginLeft: "1em", marginRight: "1em" }}
        >
          <ShipmentSearchBar backgroundColor={Colors.background.GRAY} />
        </glamorous.Div>
        <Section>
          <PanelContainer>
            <AllShipmentsPanel
              allShipmentsTotals={allShipmentsTotals}
              pushSearchView={pushSearchView}
              searchShipments={searchShipments}
              exceptionTypes={exceptionTypes}
              setSearchFilter={setSearchFilter}
              clearSearchFilters={clearSearchFilters}
              setSearchCategory={setSearchCategory}
              setSearch={setSearch}
            />
            <glamorous.Div
              css={{
                display: "flex",
                flexBasis: "100%",
                justifyContent: "space-between",
                alignContent: "flex-end",
                fontSize: "1.5em",
                fontWeight: "300",
                color: Colors.background.GRAY_BLUE,
                marginTop: "0.5em",
                marginBottom: "0.5em",
                marginLeft: "14px"
              }}
            >
              My Watchlist
              <glamorous.Div
                css={{
                  display: "flex",
                  alignItems: "flex-end",
                  fontSize: "0.7em",
                  fontWeight: "400",
                  fontStyle: "italic",
                  textDecoration: "underline",
                  color: Colors.background.GRAY_BLUE,
                  ":hover": { cursor: "pointer" }
                }}
                onClick={() =>
                  this.setState({
                    selectedWatchlistItem: null,
                    showWatchlistModal: true
                  })
                }
              >
                + Add to Watchlist
              </glamorous.Div>
            </glamorous.Div>
            {watchlistPanels}
          </PanelContainer>
          <EventsListContainer />
          <WatchlistModal
            watchlistItem={selectedWatchlistItem}
            show={showWatchlistModal}
            hide={() => this.setState({ showWatchlistModal: false })}
          />
        </Section>
      </glamorous.Div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/shipment-status/ShipmentStatusView.js